export const dualChartColors = {
    backgroundColors: ['rgba(54, 162, 235, 0.2)', 'rgba(75, 192, 192, 0.2)'],
    borderColors: ['rgba(54, 162, 235, 1)', 'rgba(75, 192, 192, 1)'],
};
